import { Button } from 'system/atoms';

type Props = {
  text?: string;
  onClick: () => void;
};

export const CampaignCreationSkipButton = ({
  text = 'Skip',
  onClick
}: Props) => {
  return (
    <Button variant="secondary" onClick={onClick}>
      {text}
    </Button>
  );
};
